import { NgModule } from '@angular/core';
import { Routes, RouterModule, Router } from '@angular/router';
import { CreateUserMmaxComponent } from '../components/forms/create-user-mmax/create-user-mmax.component';
import { LoginFormMmaxComponent } from '../components/forms/login-form-mmax/login-form-mmax.component';
import { ResetPassMmaxComponent } from '../components/forms/reset-pass-mmax/reset-pass-mmax.component';
import { SucursalesmmaxComponent } from '../components/forms/sucursalesmmax/sucursalesmmax.component';
import { MmaxofertasviewComponent } from '../components/mmax-ofertasview/mmax-ofertasview.component';
import { FrecuentesMmaxviewComponent } from './frecuentes-mmaxview/frecuentes-mmaxview.component';
import { HelpBarMmaxComponent } from './help-bar-mmax/help-bar-mmax.component';
import { HistorialMMaxComprasComponent } from '../components/historial-mmax-compras/historial-mmax-compras.component';
import { MisdatosmmaxComponent } from '../components/misdatosmmax/misdatosmmax.component';
import { MmaxGeneralComponent } from './mmax-general/mmax-general.component';
import { MmaxhomeLandpageComponent } from './mmaxhome-landpage/mmaxhome-landpage.component';
import { AyudayPregummaxComponent } from '../components/ayuday-pregummax/ayuday-pregummax.component';
import { MmaxCatalogoComponent } from '../components/mmax-catalogo/mmax-catalogo.component';
import { MmaxTrackingPedidosComponent } from '../components/mmax-tracking-pedidos/mmax-tracking-pedidos.component';
import { MmaxCheckoutCompraComponent } from '../components/mmax-checkout-compra/mmax-checkout-compra.component';
import { MarcasDestmmaxComponent } from '../components/marcas-destmmax/marcas-destmmax.component';
import { MmaxSearchResultsComponent } from '../components/mmax-search-results/mmax-search-results.component';
import { ResumenComprammaxComponent } from '../components/resumen-comprammax/resumen-comprammax.component';
import { MmaxCierreCarroComponent } from '../components/mmax-cierre-carro/mmax-cierre-carro.component';
import { MmaxEndLineComponent } from '../components/mmax-end-line/mmax-end-line.component';
import { MmaxEndLineCpComponent } from '../components/mmax-end-line-cp/mmax-end-line-cp.component';
import { BeneficiosMmaxComponent } from '../components/beneficios-mmax/beneficios-mmax.component';
import { AuthGuard } from './auth.guard';  

const routes: Routes = [
  {
    path: '', component: MmaxGeneralComponent, children: [
      { path: 'resumendecompra', component: ResumenComprammaxComponent, canActivate: [AuthGuard] },
      { path: 'marcas', component: MarcasDestmmaxComponent, canActivate: [AuthGuard] },
      { path: 'ayudas', component: AyudayPregummaxComponent },
      { path: 'historial', component: HistorialMMaxComprasComponent, canActivate: [AuthGuard] },
      { path: 'sucursales', component: SucursalesmmaxComponent, canActivate: [AuthGuard] },
      { path: 'ofertas', component: MmaxofertasviewComponent, canActivate: [AuthGuard] },
      { path: 'catalogo', component: MmaxCatalogoComponent, canActivate: [AuthGuard] },
      { path: 'misdatos', component: MisdatosmmaxComponent, canActivate: [AuthGuard] },
      { path: 'beneficios', component: BeneficiosMmaxComponent, canActivate: [AuthGuard] },
      { path: 'busqueda', component: MmaxSearchResultsComponent, canActivate: [AuthGuard]  },
      { path: 'detallepedido', component: MmaxTrackingPedidosComponent, canActivate: [AuthGuard] },
      { path: '', component: MmaxhomeLandpageComponent , canActivate: [AuthGuard] },
      { path: 'login', component: LoginFormMmaxComponent },
    ]
  },
  {
    path: 'ayuda', component: HelpBarMmaxComponent, children: [
      { path: 'crearcuenta', component: CreateUserMmaxComponent },
      { path: 'resetpassword', component: ResetPassMmaxComponent },
      { path: 'login', component: LoginFormMmaxComponent },
      { path: '', component: AyudayPregummaxComponent }
    ]
  },

  {
    path: 'checkout', component: HelpBarMmaxComponent, children: [
      { path: '', component: MmaxCheckoutCompraComponent, canActivate: [AuthGuard] },
      { path: 'finalizar', component: MmaxCierreCarroComponent, canActivate: [AuthGuard] },
      { path: 'finalizado', component: MmaxEndLineComponent },
      { path: 'finalizadocp', component: MmaxEndLineCpComponent },
      { path: 'ayuda', component: AyudayPregummaxComponent }
    ]
  },
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})

export class MarianoRoutingModule {}
